var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "m-0 mb-4 billing-history-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("pages.billing.transaction")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "table-scroll-wrapper" },
      [
        _c(
          "el-table",
          {
            staticClass: "table-normalize",
            attrs: { data: _vm.getPaymentHistory, stripe: "" },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "created_at",
                label: `${_vm.$t("dialogs.paymentHistory.tableColumns.date")}`,
                align: "center",
                formatter: _vm.dateFormatter,
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "customer_name",
                align: "center",
                label: `${_vm.$t(
                  "dialogs.paymentHistory.tableColumns.profileOwner"
                )}`,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: `${_vm.$t(
                  "dialogs.paymentHistory.tableColumns.pricePlan"
                )}`,
                align: "center",
                width: "200",
                formatter: _vm.formatter,
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "currency",
                label: `${_vm.$t(
                  "dialogs.paymentHistory.tableColumns.currency"
                )}`,
                align: "center",
                width: "90",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "sale_gross",
                label: `${_vm.$t(
                  "dialogs.paymentHistory.tableColumns.totalAmount"
                )}`,
                width: "130",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "receipt_url",
                label: `${_vm.$t(
                  "dialogs.paymentHistory.tableColumns.invoice"
                )}`,
                width: "130",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "a",
                        {
                          staticClass: "billing-download-link",
                          attrs: {
                            href: scope.row.receipt_url,
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("dialogs.paymentHistory.download"))
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }